module.exports = __webpack_public_path__ + "fb7b2e51975f8d7cecb059ef4bac0b14.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-320.webp.png
// module id = 300
// module chunks = 0